import React, { useRef, useEffect, useState, useCallback } from 'react';
import { GoogleMap, useJsApiLoader, Polyline, Marker } from '@react-google-maps/api';
import useWindowWidth from 'src/hooks/useWindowWidth';
import { TABLET_MIN_WIDTH } from 'src/styles/breakpoints';

function Map({locations}) {
  const windowWidth = useWindowWidth();
  const smallScreen = windowWidth < TABLET_MIN_WIDTH;
  const center = {lat: 39.0473, lng: -95.6752};
  const containerStyle = {
    width: '100%',
    minHeight: '400px'
  };
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_KEY
  })

  const [map, setMap] = useState(null)

  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();

    setMap(map)
  }, [])

  const onUnmount = useCallback(function callback(map) {
    setMap(null)
  }, [])
  return isLoaded && locations ? (
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={center}
        zoom={smallScreen ? 3.25 : 4.5}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        {locations?.map(location => {
          return (
            <Marker
              position={{ lat: parseFloat(location.latitude), lng: parseFloat(location.longitude)}}
            />
          )
        })}
      </GoogleMap>
  ) : <></>
}

export default Map